// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".undoToasts_orzCclwJ{position:fixed;top:60px;right:20px;z-index:var(--z-50)}.undoToast_4Qpckboo{background-color:var(--color-gray-100);color:var(--color-body-color);position:relative;z-index:var(--z-50);width:270px;font-size:1em;border:1px solid var(--color-gray-200);box-shadow:0 .25rem .75rem rgba(0,0,0,.1);border-radius:.25rem;margin-top:20px;padding:10px 20px}.undoToastEnter_CPw0i9-p{opacity:0}.undoToastEnterActive_nCl-1n-b{opacity:1;transition:opacity 200ms}.undoToastLeave_wB51vcSu{opacity:1}.undoToastLeaveActive_-RuPPBfl{opacity:0;transition:opacity 100ms}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"undoToasts": "undoToasts_orzCclwJ",
	"undoToast": "undoToast_4Qpckboo",
	"undoToastEnter": "undoToastEnter_CPw0i9-p",
	"undoToastEnterActive": "undoToastEnterActive_nCl-1n-b",
	"undoToastLeave": "undoToastLeave_wB51vcSu",
	"undoToastLeaveActive": "undoToastLeaveActive_-RuPPBfl"
};
export default ___CSS_LOADER_EXPORT___;
